import { CodeBase } from "./_codeBase";

/** コマンド区分*/
export class CommandDiv extends CodeBase<CommandDiv>
{

    /** コマンド区分: "01", "ユーザ"*/
    public static readonly USER: CommandDiv = new CommandDiv("01", "ユーザ", "");
    /** コマンド区分: "02", "バッチ"*/
    public static readonly BATCH: CommandDiv = new CommandDiv("02", "バッチ", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): CommandDiv[] {
        return [
            CommandDiv.USER,
            CommandDiv.BATCH
        ];
    }
}
